// Mirrors Program::GRADES and Program::GRADE_LEVELS_FOR_GRADE_RANGES: grade is stored as the index
// into GRADES (0 is K), and the level label is derived from it on save.
const GRADES = ['K', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];

export interface GradeOption {
  label: string;
  value: number;
}

export const GRADE_OPTIONS: GradeOption[] = GRADES.map((label, value) => ({ label, value }));

export const gradeLevelFor = (grade: number | null): string | null => {
  if (grade === null) return null;
  if (grade <= 2) return 'K-2';
  if (grade <= 5) return '3-5';
  if (grade <= 8) return '6-8';
  return '9-12';
};
